export enum EmailProvidersQueryKeys {
  Primary = '/email-providers',
}
